<div class="app-container container">
    <div class="app-links-mockup">
        <div class="app-links">
            <h2>{{this.word[this.language].downloadOurApp}}</h2>
            <p class="app-text-small">
                {{this.word[this.language].zavedeniaApp}}
            </p>
            <div class="app-download-links">
                <a href="https://play.google.com/store/apps/details?id=com.zavedenia.app&hl=en&gl=US" rel="noreferrer"
                    target="_blank">
                    <img width="170" height="50" loading="lazy" src="assets/images/google-play-banner.png"
                        alt="{{this.word[this.language].zavedeniaBG}} Google Play" class="to-app-store"></a>
                <a  href="https://apps.apple.com/us/app/zavedenia/id477040256" rel="noreferrer" target="_blank">
                    <img  width="170" height="50"  loading="lazy" src="assets/images/appstore-banner.png"
                        alt="{{this.word[this.language].zavedeniaBG}} Apple store" class="to-app-store"></a>
            </div>
        </div>
        <img loading="lazy" width="564" height="856" class="app-mockup" src="assets/images/app-mockup-min.png"
            alt="{{this.word[this.language].zavedenia}}">
    </div>
</div>
